import { gateway } from "src/gateway";

export enum EPaymentMethod {
  STRIPE = "stripe",
  PAYPAL = "paypal",
}

export interface IInvoicePaymentMethod {
  provider: string;
  paymentUrl?: string | null;
  externalOrderUid?: string | null;
  externalMerchantId?: string | null;
  fee?: number | null;
  paidAt?: string | null;
  webhookId?: string | null;
  netAmount?: number | null;
  grossAmount?: number | null;
  transactionId?: string | null;
  stripeCheckoutStatus?: string | null;
  stripeCheckoutExpiresAt?: string | null;
}

export interface ICreatePaymentOrderPayload {
  invoiceUid: string;
  provider: "stripe" | "paypal";
  amount?: number;
  token?: string | null;
}

export interface ICreatePaymentOrderResponse {
  paymentMethod: IInvoicePaymentMethod;
  paymentMethods: IInvoicePaymentMethod[];
  refreshed: boolean;
}

export const createPaymentOrder = async ({
  invoiceUid,
  provider,
  amount,
  token,
}: ICreatePaymentOrderPayload): Promise<ICreatePaymentOrderResponse> => {
  const localToken = sessionStorage.getItem("token");

  const response = await gateway.post(
    `/invoices/payment/create-order`,
    {
      invoiceUid,
      provider,
      amount,
    },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : { Authorization: `Bearer ${localToken}` },
    },
  );

  return response.data.data;
};
